var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-m padded"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"centered"},[_c('h3',[_vm._v(_vm._s(_vm.t('Passing you to upgrade form')))]),_c('PoweredBy')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }